import React from "react";
import { JobStatus } from "../apiResources/Job";
import { TagStatus } from "../types";
import StatusTag from "./StatusTag";

const JobStatusTag = (props: JobStatusTagProps) => {
  const { status } = props;
  let label = status.replace("_", " ");

  if (status === JobStatus.INTERVIEW) {
    label = "Interview";
  }

  return <StatusTag status={convertToGenericStatus(status)}>{label}</StatusTag>;
};

type JobStatusTagProps = {
  status: JobStatus;
};

const convertToGenericStatus = (status: JobStatus): TagStatus => {
  switch (status) {
    case JobStatus.EXPIRED:
    case JobStatus.CLOSED:
      return "default";
    case JobStatus.NEW:
    case JobStatus.OPEN:
      return "success";
    case JobStatus.INTERVIEW:
    case JobStatus.OFFER:
      return "info";
    case JobStatus.FILLED:
      return "warning";
  }
};

export default JobStatusTag;
